(() => {
  if (customElements.get('image-slider')) return;

  class ImageSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const container = this.querySelector('[data-slider]');
      if (!container) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        initialSlide: 1,
        slidesPerView: 1.3,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        loopAdditionalSlides: 2,
        centeredSlides: false,
        spaceBetween: 18,
        breakpoints: {
          768: {
            spaceBetween: 23,
            slidesPerView: 2,
            centeredSlides: true,
            centeredSlidesBounds: true,
          },
          990: {
            centeredSlides: false,
            slidesPerView: 2,
            spaceBetween: 34,
          },
        },
      };

      if (this.hasAttribute('data-loop')) {
        this.options.loop = true;
      }

      if (this.hasAttribute('data-autoplay')) {
        const delay = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
        this.options.autoplay = {
          delay: delay,
          disableOnInteraction: false,
        };
      }

      this.slider = new Swiper(container, this.options);
    }
  }

  customElements.define('image-slider', ImageSlider);
})();
